import React, { useContext, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";
import { nullCheck } from "../../../../../../utils/dataHelpers";
import { LoadService } from "../../../../../../services/LoadService";
import { AlertContext } from "../../../../../Dashboard/Dashboard";

export default function PostLoadAction({ load, active, rowId, updateData }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const brokerageStatus = nullCheck(load, null, "brokerageStatus");
  const datId = nullCheck(load, null, "datId");
  const buttonColor = active ? "white" : datId ? "orange" : "blue";

  const handleClick = () => {
    setIsLoading(true);
    setTimeout(() => {
      if (datId) {
        setIsLoading(true);
        LoadService.UnpostLoad(instance, load).then(res => {
          setIsLoading(false);
          if (res.success) updateData(rowId, "datId", null);
          else warning("Load unpost from DAT unsuccessful");
        }).catch(error => {
          console.error(error);
          setIsLoading(false);
          warning("Load unpost from DAT unsuccessful");
        });
      } else {
        setIsLoading(true);
        LoadService.PostLoad(instance, load).then(res => {
          setIsLoading(false);
          if (res.success) updateData(rowId, "datId", res.id);
          else warning("Load post to DAT unsuccessful");
        }).catch(error => {
          console.error(error);
          setIsLoading(false);
          warning("Load post to DAT unsuccessful");
        });
      }
    }, 1000);
  };

  const getTooltip = () => {
    if (isLoading) return "Loading";
    else if (brokerageStatus !== "AVA") return "Load not available for posting";
    else if (datId) return "Unpost from DAT";
    else return "Post to DAT";
  };

  return (
    <StyledTooltip title={getTooltip()}>
      <Box>
        <InlineIconButton
          onClick={handleClick}
          icon={SendOutlinedIcon}
          buttonColor={buttonColor}
          disabled={isLoading || brokerageStatus !== "AVA"}
        />
      </Box>
    </StyledTooltip>
  );
}

PostLoadAction.propTypes = {
  load: PropTypes.object.isRequired,
  active: PropTypes.bool,
  rowId: PropTypes.number,
  updateData: PropTypes.func,
};